import { render, staticRenderFns } from "./TypesBadgeList.vue?vue&type=template&id=1adf15fb&scoped=true&"
import script from "./TypesBadgeList.vue?vue&type=script&lang=js&"
export * from "./TypesBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./TypesBadgeList.vue?vue&type=style&index=0&id=1adf15fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf15fb",
  null
  
)

export default component.exports